import Footer from "Components/Common/Footer/Footer";
import Header from "Components/Common/Header/Header";
import MyMeetingList from "Components/MyMeetings/MyMeetingList/MyMeetingList";

const MyMeetings = () => {
  const eventId = localStorage.getItem("eventId");

  return (
    <>
      <Header moduleName={"mymeeting"} />

      <section className="inner_sec">
        <div className="container">
          <MyMeetingList eventId={eventId} showTitle={true} />
        </div>
      </section>
      <Footer />
    </>
  );
};

export default MyMeetings;
